export const ROUTES = {
    /**
     * All Lead routes
     */
    LEADS: "/lead",
    LEADS_DETAILS: "/leads/details",
    SINGLE_LEADS: "/lead/:id",
    NEW_SINGLE_LEADS: "/leads/new",
    /**
     * All Client routes
     */
    CLIENTS: "/client",
    CLIENTS_DETAILS: "/client/details",
    CLIENTS_ACTIVITY: "/client/activity",
    CLIENTS_PRODUCTION: "/client/production",
    SINGLE_CLIENTS: "/client/:id",
    SINGLE_CLIENTS_OVERALL: "/client/:id/overall",
    SINGLE_CLIENTS_TAB: "/client/:id/:tab",
    NEW_SINGLE_CLIENTS: "/clients/new",
    /**
     * Business routes
     */
    BUSINESS: "/business",
    SINGLE_BUSINESS: "/business/:id",
    SINGLE_BUSINESS_OVERALL: "/business/:id/overall",
    SINGLE_BUSINESS_TAB: "/business/:id/:tab",
    NEW_SINGLE_BUSINESS: "/business/new",
    /**
     * All opportunities routes
     */
    RE_OPPORTUNITIES: "/opportunities-re",
    BUYER_SELLER_OPPORTUNITIES: "/opportunities-buyer-seller",
    CR_OPPORTUNITIES: "/opportunities-cr",
    MORTGAGE_OPPORTUNITIES: "/opportunities-mortgage",
    HELOC_OPPORTUNITIES: "/opportunities-heloc",
    /**
     * All employee routes
     */
    EMPLOYEES: "/employee",
    SINGLE_EMPLOYEES: "/employee/:id",
    NEW_SINGLE_EMPLOYEES: "/employee/new",
    /**
     * All User routes
     */
    SINGLE_USERS: "/users/:id",
    NEW_SINGLE_USERS: "/user/new",
    USERS: "/users",
    USER_PROFILE: "/profile",
    /**
     * All Conversation routes
     */
    CONVERSATIONS: "/conversations",
    SINGLE_CONVERSATION: "/conversation/:id",
    NEW_SINGLE_CONVERSATION: "/conversation/new",
    /**
     *
     */
    /**
     * Activity Screen
     */
    ACTIVITY: "/activities",
    SINGLE_ACTIVITY: "/activity/:id",
    /**
     * Calendar Screens
     */
    CALENDAR: "/calendar",
    /**
     * Refinance Cash Out
     */
    REFINANCE_CASH_OUT: "/client/refinance-cash-out",
    /**
     * Task Screens
     */
    NEW_TASK: "/calendar?task=new",
    /**
     * Appointment Screens
     */
    NEW_APPOINTMENT: "/calendar?appointment=new",
    /**
     * Home routes
     */
    HOME: "/",
    DASHBOARD: "/dashboard",
    /**
     * Communications screen
     */
    COMMUNICATIONS: "/comunications",
    CAMPAIGNS: "/comunications/campaigns",
    NEW_CAMPAIGN: "/campaign/new",
    SINGLE_CAMPAIGN: "/campaign/:id",
    BULK_CONVERSATION: "/comunications/bulk-message",
    NEW_BULK_CONVERSATION: "/comunications/bulk-message/new",
    SINGLE_BULK_CONVERSATION: "/comunications/bulk-message/:id",
    /**
     * Setting screen
     */
    SETTINGS: "/settings",
    NEW_SETTING: "/settings/new",
    SINGLE_SETTING: "/settings/:id",
    /**
    /**
     * Groups screen
     */
    GROUPS: "/groups",
    /**
     * Tutorials screen
     */
    TUTORIALS: "/tutorials",
    /**
     * PAYMENTS screen
     */
    PAYMENTS: "/payments",
    /**
     * Analytics screen
     */
    ANALYTICS: "/analytics",
    ANALYTICS_CHAT: "/analytics/chat",
    ANALYTICS_CREDIT_SALES: "/analytics/credit-sales",
    ANALYTICS_TELEMARKETING: "/analytics/telemarketing",
    ANALYTICS_RE_COMMISSIONS: "/analytics/re-commissions",
    ANALYTICS_ADS: "/analytics/reports/ads-analytics",

    /**
     * TeamHub screen
     */
    TEAMHUB: "/teamhub",
    TEAMHUB_TEMPLATES: "/teamhub/templates",

    /**
     * TeamHub — Schedule and Holidays
     */
    TEAMHUB_SCHEDULE: "/teamhub/schedule",
    TEAMHUB_SCHEDULE_CALENDAR: "/teamhub/schedule/calendar",
    TEAMHUB_SCHEDULE_SCHEDULES: "/teamhub/schedule/schedules",
    TEAMHUB_SCHEDULE_VACATIONS: "/teamhub/schedule/vacations",
    TEAMHUB_SCHEDULE_HOLIDAYS: "/teamhub/schedule/holidays",
    TEAMHUB_SCHEDULE_LIVE_ATTENDANCE: "/teamhub/schedule/live-attendance",
    TEAMHUB_SCHEDULE_TIMECARD_REPORT: "/teamhub/schedule/timecard-report",

    /**
     * TeamHub — Tools
     */
    TEAMHUB_TOOLS: "/teamhub/tools",
    TEAMHUB_TOOLS_RDC_CREDIT_COST_CLOSER: "/teamhub/tools/rdc-credit-cost-closer",

    /**
     * TeamHub — Tickets
     */
    TEAMHUB_TICKETS: "/teamhub/tickets",
    TEAMHUB_TICKETS_MINE: "/teamhub/tickets/mine",
    TEAMHUB_TICKETS_SUGGESTIONS: "/teamhub/tickets/suggestions",
    TEAMHUB_TICKETS_ALL: "/teamhub/tickets/all",

    /**
     * Not found route AKA 404 page
     */
    NOT_FOUND: "*",
};
